import type { Route } from 'vue-router';
import type { FilterQuery } from '~/components/filter/filter-types';
import Parser from './parser';
import Serializer from './serializer';

export function parseFilterParams(route: Route) {
  const parser = new Parser(route);
  return parser.getVars();
}

export function serializeFilterParams(vars: FilterQuery) {
  const serializer = new Serializer(vars);
  return serializer.getRoute();
}

export default {
  parse: parseFilterParams,
  serialize: serializeFilterParams,
};
